import isEmpty from 'lodash/isEmpty'
import isString from 'lodash/isString'
import getConfig from 'next/config'
import { useCallback } from 'react'

import { useSplitTest } from '@Globals/SplitTests/Hooks'

interface EmailSuggestion {
  suggestion: string
  verdict: string
}

export const useEmailSuggestion = () => {
  const enableEmailSuggestion = useSplitTest('email_suggestion_v1', 'b')
  const { publicRuntimeConfig } = getConfig()

  const fetchEmailSuggestEmail: (email) => Promise<EmailSuggestion | null> = useCallback(async (email) => {
    if (!isEmpty(publicRuntimeConfig.apiEndpoint) && isString(email) && enableEmailSuggestion) {
      const raw = await fetch(`${publicRuntimeConfig.apiEndpoint}/v2/communication/emailValidation`, {
        method: 'post',
        body: JSON.stringify({
          email,
          source: 'success',
        }),
      })
      const result = await raw.json()
      if (result.suggestion) {
        const suggestedEmail = `${email.split('@')[0]}@${result.suggestion}`
        return { suggestion: suggestedEmail, verdict: result.verdict }
      }

      return result
    }
    return null
  }, [enableEmailSuggestion, publicRuntimeConfig.apiEndpoint])

  return { fetchEmailSuggestEmail }
}
